module.exports = __webpack_public_path__ + "img/Tommy Tuberville.3691963c.jpg";